import React, { useEffect } from 'react'

import { NoData, SinglePanePage, screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import Brand from 'helpers/brand'

import styled from 'styled-components'

import { signOut } from 'aws-amplify/auth'
import { clearAuthSessionCache } from 'services/authSessionCache'

const SignOut = () => {
  useEffect(() => {
    const amplifySignOut = async () => {
      clearAuthSessionCache()
      await signOut()
    }

    amplifySignOut().catch((error) => {
      console.error('Error signing out:', error)
    })
  }, [])

  return (
    <S.PaneContainer>
      <S.SinglePanePage>
        <S.ProductLogo src={Brand.productLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
        <NoData>
          <h1>You are being signed out</h1>
          <h2>You will soon be redirected to the login page.</h2>
        </NoData>
        <S.BrandLogo src={Brand.brandLogoPath()} aria-label="brand-logo" alt={`${Brand.brandLogoPath()} logo`} />
      </S.SinglePanePage>
    </S.PaneContainer>
  )
}

const S = {
  PaneContainer: styled.div`
    background-color: ${color('background')};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
  `,
  SinglePanePage: styled(SinglePanePage)`
    margin-top: 40px;

    @media ${screenSize.small} {
      margin: 20px;
      border-radius: 16px;
    }
  `,
  LoginPageLink: styled.a`
    color: ${color('anchor')};
    text-decoration: none;
    cursor: pointer;
  `,
  Header: styled.div`
    background-color: ${color('paneBackground')};
  `,
  ProductLogo: styled.img`
    height: 33px;
    float: right;
  `,
  BrandLogo: styled.img`
    height: 40px;
  `
}

export default SignOut
